import { defineStore } from "pinia";
const globalStore = defineStore("global", {
    state: () => {
        return { isNavOpen: false, isModalOpen: false, selectMenu: "" as string | null, chart: "" as string | null };
    },
    actions: {
        setNavOpen(isNavOpen: boolean) {
            this.isNavOpen = isNavOpen;
        },
        setModalOpen(isModalOpen: boolean) {
            this.isModalOpen = isModalOpen;
        },
        setSelectMenu(selectMenu: string | null) {
            this.selectMenu = selectMenu;
        },
        setChart(chart: string | null) {
            this.chart = chart;
        },
    },
});

export default globalStore;
